export default __webpack_public_path__ + "static/media/footerCopyright.e65b992e.svg";